import { styled } from "styled-components";

import { ModalButton } from "shared/ui/buttons";
import { confirmDialog, confirmLeaveIfDirty, ModalShell } from "shared/ui/feedback";
import { ChipGroup } from "shared/ui/filters";
import { ButtonBar } from "shared/ui/layout";

// 구분 칩. 서버 category 값(1/2/4)을 칩 value로, onClickCategory는 칩 인덱스(0/1/2)를 받는다.
const CATEGORY_OPTIONS = [
  { label: "일반", value: 1 },
  { label: "관리자", value: 2 },
  { label: "마스터", value: 4 },
];
const CATEGORY_VALUE_TO_INDEX = { 1: 0, 2: 1, 4: 2 };

const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
  margin: 40px 0;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

const Modal = ({
  // 모달 창 오픈
  isModalOpen,
  setIsModalOpen,
  adminPage,
  // 회원 정보 관련
  name,
  category,
  onClickCategory,
  email,
  createdAt,
  updatedAt,
  // 탈퇴 컨펌 모달 관련
  onWithdraw,
  // 취소 컨펌 모달 관련
  onCancel,
  // 수정 컨펌 모달 관련
  onConfirm,
  // 변경 사항이 없으면 '수정' 버튼 비활성화
  confirmDisabled = false,
  // 변경 사항이 있을 때만 취소 확인 모달 노출
  dirty = false,
}) => {
  const handleWithdrawClick = async () => {
    const shouldProceed = await confirmDialog(
      "강제 탈퇴 시 사용자에 대한 모든 정보가 사라지게 됩니다.\n그래도 탈퇴 시키시겠습니까?"
    );

    if (shouldProceed) {
      onWithdraw();
    }
  };

  const handleCancelClick = async () => {
    const shouldProceed = await confirmLeaveIfDirty(
      dirty,
      "취소 시 수정한 내용들이 반영되지 않습니다.\n그래도 취소하시겠습니까?"
    );

    if (shouldProceed) {
      onCancel();
    }
  };

  const handleConfirmClick = async () => {
    const shouldProceed = await confirmDialog(
      "회원 정보를 수정하시겠습니까?\n회원님의 정보가 수정하신 정보들로 변경됩니다."
    );

    if (shouldProceed) {
      onConfirm();
    }
  };

  return (
    <ModalShell
      isOpen={isModalOpen}
      onRequestClose={() => setIsModalOpen(false)}
    >
      <h2 style={{ fontWeight: "bold" }}>정보 관리</h2>
      <Column style={{ flexGrow: "1" }}>
        <Row>
          <span style={{ flexBasis: "100px" }}>이름</span>
          <span>{name}</span>
        </Row>
        <Row style={{ marginTop: "22px" }}>
          <span style={{ flexBasis: "100px" }}>구분</span>
          <ChipGroup
            options={CATEGORY_OPTIONS.map((option) => ({
              ...option,
              disabled: !adminPage,
            }))}
            value={category}
            onChange={(value) => onClickCategory(CATEGORY_VALUE_TO_INDEX[value])}
            allowDeselect={false}
          />
        </Row>
        <Row style={{ marginTop: "22px" }}>
          <span style={{ flexBasis: "100px" }}>이메일</span>
          <span>{email}</span>
        </Row>
        <Row style={{ marginTop: "22px" }}>
          <span style={{ flexBasis: "100px" }}>가입일</span>
          <span>{createdAt}</span>
        </Row>
        <Row style={{ marginTop: "22px" }}>
          <span style={{ flexBasis: "100px" }}>최근 로그인</span>
          <span>{updatedAt}</span>
        </Row>
      </Column>
      {adminPage ? (
        <ButtonBar style={{ gap: "30px" }}>
          <ModalButton onClick={handleWithdrawClick}>탈퇴</ModalButton>
          <ModalButton onClick={handleCancelClick}>취소</ModalButton>
          <ModalButton
            style={{
              color: "white",
              backgroundColor: confirmDisabled ? "#CFD4D9" : "#0079E0",
              cursor: confirmDisabled ? "not-allowed" : "pointer",
            }}
            onClick={handleConfirmClick}
            disabled={confirmDisabled}
          >
            수정
          </ModalButton>
        </ButtonBar>
      ) : (
        <ButtonBar>
          <ModalButton
            style={{ color: "white", backgroundColor: "#0079E0" }}
            onClick={() => setIsModalOpen(false)}
          >
            확인
          </ModalButton>
        </ButtonBar>
      )}
    </ModalShell>
  );
};

export default Modal;
